export default "__VITE_ASSET__e1059dd4__"